module.exports = __webpack_public_path__ + "img/c2c-bg.2e0845ae.svg";